import type {
  ChainId_CronosEvm,
  ChainId_L1,
  ChainId_L2,
} from '@cronos-app/sdk';
import {
  ADDRESS_BY_CHAIN_CRONOS_EVM,
  ADDRESS_BY_CHAIN_L1,
  ADDRESS_BY_CHAIN_L2,
  ChainId,
  ChainLayer,
  getRelatedCronosEvmChain,
  getRelatedL2Chain,
  isChainIdL1,
  isChainIdL2,
  SDK_CronosEvm,
  SDK_L1,
  SDK_L2,
} from '@cronos-app/sdk';
import { getAddEthereumChainParameter } from '@cronos-app/wallet';

export const getSDKs = (chainId: ChainId_L1) => ({
  [ChainLayer.L1]: SDK_BY_CHAIN_L1[chainId],
  [ChainLayer.L2]: SDK_BY_CHAIN_L2[getRelatedL2Chain(chainId)],
  [ChainLayer.CronosEvm]:
    SDK_BY_CHAIN_CRONOS_EVM[getRelatedCronosEvmChain(chainId)],
});

export const getL1SDK = (chainId: ChainId_L1) => SDK_BY_CHAIN_L1[chainId];
export const getL2SDK = (chainId: ChainId_L2) => SDK_BY_CHAIN_L2[chainId];

export function getSDK(chainId: ChainId_L1): SDK_L1;
export function getSDK(chainId: ChainId_L2): SDK_L2;
export function getSDK(chainId: ChainId_CronosEvm): SDK_CronosEvm;
export function getSDK(chainId: ChainId_L1 | ChainId_L2 | ChainId_CronosEvm) {
  if (isChainIdL1(chainId)) {
    return getL1SDK(chainId);
  }
  if (isChainIdL2(chainId)) {
    return SDK_BY_CHAIN_L2[chainId];
  }
  return SDK_BY_CHAIN_CRONOS_EVM[chainId];
}

const genSDK_L1 = (chainId: ChainId_L1) => {
  const { chainName, rpcUrls } = getAddEthereumChainParameter(chainId);
  const rpcUrl = rpcUrls[0];
  return new SDK_L1(
    {
      chainName,
      chainId,
      rpcUrl,
    },
    ADDRESS_BY_CHAIN_L1[chainId],
  );
};
const genSDK_L2 = (chainId: ChainId_L2) => {
  const { chainName, rpcUrls } = getAddEthereumChainParameter(chainId);
  const rpcUrl = rpcUrls[0];
  return new SDK_L2(
    {
      chainName,
      chainId,
      rpcUrl,
    },
    ADDRESS_BY_CHAIN_L2[chainId],
  );
};
const genSDK_CronosEvm = (chainId: ChainId_CronosEvm) => {
  const { chainName, rpcUrls } = getAddEthereumChainParameter(chainId);
  const rpcUrl = rpcUrls[0];
  return new SDK_CronosEvm(
    {
      chainName,
      chainId,
      rpcUrl,
    },
    ADDRESS_BY_CHAIN_CRONOS_EVM[chainId],
  );
};

const SDK_BY_CHAIN_L1 = {
  [ChainId.ETHEREUM]: genSDK_L1(ChainId.ETHEREUM),
  [ChainId.SEPOLIA]: genSDK_L1(ChainId.SEPOLIA),
};

const SDK_BY_CHAIN_CRONOS_EVM = {
  [ChainId.CRONOS_EVM_MAINNET]: genSDK_CronosEvm(ChainId.CRONOS_EVM_MAINNET),
  [ChainId.CRONOS_EVM_TESTNET]: genSDK_CronosEvm(ChainId.CRONOS_EVM_TESTNET),
};

const SDK_BY_CHAIN_L2 = {
  [ChainId.ZK_EVM]: genSDK_L2(ChainId.ZK_EVM),
  [ChainId.ZK_EVM_TEST]: genSDK_L2(ChainId.ZK_EVM_TEST),
};
